import { Directive, TemplateRef, Input } from '@angular/core';

@Directive({
  selector: '[fFielUpload],[fFileUpload]',
})
export class FFileUploadDirective {
  constructor(
    public templateRef: TemplateRef<any>
  ) { 
  }

}